import React from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Form } from "antd";

function ContactInput({ name, label, required = true, placeholder, disabled, value, onChange, defaultCountry }) {
  return (
    <Form.Item
      name={name}
      label={label}
      rules={[
        {
          required,
          message: "Please enter phone number!",
        },
        {
          validator(_, value) {
            if (value && !isValidPhoneNumber(value)) {
              return Promise.reject(new Error("Invalid Contact Number"));
            }
            return Promise.resolve();
          },
        },
      ]}
      style={{ marginBottom: 0 }}
    >
      <PhoneInput
        international
        defaultCountry={defaultCountry || "IN"}
        value={value}
        onChange={onChange}
        placeholder={placeholder || "Enter phone number"}
        limitMaxLength
        disabled={disabled}
      />
    </Form.Item>
  );
}

export default ContactInput;
